module.exports = __webpack_public_path__ + "img/HomeHeroPath.b0dea227.svg";